import { render, staticRenderFns } from "./ModalSendMessage.vue?vue&type=template&id=1a03bac4&"
import script from "./ModalSendMessage.vue?vue&type=script&lang=js&"
export * from "./ModalSendMessage.vue?vue&type=script&lang=js&"
import style0 from "./ModalSendMessage.vue?vue&type=style&index=0&id=1a03bac4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports